export enum BasketState {
  empty = 'empty',
  draft = 'draft',
  paymentPending = 'payment-pending',
  paid = 'paid',
  cancelled = 'cancelled',
  deliveryPending = 'delivery-pending',
  delivered = 'delivered',
}
